/**
 * Послабление для бота, ЗАСИДЕВШЕГОСЯ БЕЗ ПОЛИТИКИ (жалоба игроков 2026-09:
 * «боты подолгу не покупают политики»).
 *
 * Замер (server/scripts/tmpPolicyLagProbe.js, 192 бот-партии): бота держит не
 * бюджет, а ценовой порог. Из застрявших раундов 92% — бот не купил бы и со
 * 999 монетами, потому что покупка требует value > price, а вайтлист волны 30
 * оставляет части фракций записи с базовой ценностью NON_PREFERRED_VALUE = 2,
 * которые проходят только самый дешевый слот рынка.
 *
 * Поэтому с раунда startRound бот без политики раунд за раундом все охотнее
 * переплачивает за разрешенную ему политику (и все меньше бережет накопления
 * на стройцель). Наблюдаемо это и есть «шанс покупки, растущий с каждым
 * раундом», но БЕЗ кубика: decidePolicyStep вызывается на каждом тике фазы
 * строительства (до BOT_MAX_STEPS_PER_PHASE), и вероятностный гейт схлопнулся
 * бы в 1-(1-p)^N, то есть в «всегда».
 *
 * Послабление НЕ трогает саму ценность политики: вайтлист волны 30 и
 * анти-список волны 24 продолжают возвращать 0 и блокировать покупку. Это
 * принципиально — попытка «взять хоть что-то» вне вайтлиста уже ставилась на
 * волне 27 и откачена с -6.9 п.п. винрейта.
 *
 * @param {number} round - текущий раунд
 * @param {boolean} hasPolicy - есть ли у бота действующая политика
 * @param {Object} config
 * @param {number} config.startRound - раунд, с которого начинается послабление
 * @param {number} config.perRound - прибавка за каждый раунд
 * @param {number} config.max - потолок послабления
 * @returns {number} на сколько монет бот готов переплатить (0 — обычный режим)
 */
export const calcNoPolicyPriceRelief = (round, hasPolicy, {startRound, perRound, max}) => {
  if (hasPolicy || !round || round < startRound) {
    return 0;
  }

  return Math.min((round - startRound + 1) * perRound, max);
};
